import { graphql, useStaticQuery } from "gatsby";

export const useTravelAdvisoryQuery = (keyword) => {
  const { allStrapiTravelAdvisory } = useStaticQuery(graphql`
    query TravelAdvisory {
      allStrapiTravelAdvisory {
        nodes {
          keyword
          banner_section {
            banner_images {
              image {
                alternativeText
                url
                localFile {
                  childImageSharp {
                    gatsbyImageData(
                      layout: FULL_WIDTH
                      placeholder: BLURRED
                      formats: [WEBP, AUTO]
                      quality: 85
                      breakpoints: [400, 800, 1200, 1600, 2000]
                    )
                  }
                }
              }
              mobile_image {
                alternativeText
                url
                localFile {
                  childImageSharp {
                    gatsbyImageData(
                      layout: FULL_WIDTH
                      placeholder: BLURRED
                      formats: [WEBP, AUTO]
                      quality: 80
                      breakpoints: [375, 414, 768]
                      outputPixelDensities: [1, 1.5, 2]
                    )
                  }
                }
              }
              banner_text_1
              heading
              description_1 {
                data {
                  description_1
                }
              }
              description_2 {
                data {
                  description_2
                }
              }
              description_3 {
                data {
                  description_3
                }
              }
            }
          }

          tab_section {
            bg_color
            active_tab_color
            href
            tab_color
            tab_id
            tab_name
          }
          before_travel_section {
            heading
            heading_color
            description {
              data {
                description
              }
            }
            cards {
              card_image {
                alternativeText
                url
                localFile {
                  childImageSharp {
                    gatsbyImageData(placeholder: NONE, formats: [WEBP])
                  }
                }
              }
              heading
              heading_color
              description {
                data {
                  description
                }
              }
            }
          }
          at_airport_section {
            heading
            heading_color
            cards_section {
              heading
              heading_color
              description {
                data {
                  description
                }
              }
              card_image {
                alternativeText
                url
                localFile {
                  childImageSharp {
                    gatsbyImageData(placeholder: NONE, formats: [WEBP])
                  }
                }
              }
              card_button {
                bg_color
                href
                icon {
                  alternativeText
                  url
                  localFile {
                    childImageSharp {
                      gatsbyImageData(placeholder: NONE, formats: [WEBP])
                    }
                  }
                }
                label
                label_color
              }
              card_id
            }
          }
          faq_section {
            heading
            arrow_1 {
              alternativeText
              url
            }
            arrow_2 {
              alternativeText
              url
            }
            faq_section {
              heading {
                data {
                  heading
                }
              }
              description {
                data {
                  description
                }
              }
            }
          }
          stay_info_section {
            heading
            heading_color
            cards {
              card_image {
                alternativeText
                url
                localFile {
                  childImageSharp {
                    gatsbyImageData(placeholder: NONE, formats: [WEBP])
                  }
                }
              }
              description {
                data {
                  description
                }
              }
              heading_color
            }
          }
        }
      }
    }
  `);
  return allStrapiTravelAdvisory?.nodes?.find(
    (item) => item.keyword === keyword,
  );
};
